import React from 'react';
import './PersonCard.css';
import { Image } from '@mantine/core';

interface PersonCardProps {
    image: string | React.ReactNode;
    name: string;
    role: string;
    description: string;
}

const PersonCard: React.FC<PersonCardProps> = ({ image, name, role, description }) => {
    return (
            <div className="person-card">
                <Image src={image} radius={'10em'} h={'10em'} w={'10em'} />
                <h3 className="person-card-name">{name}</h3>
                <p className="person-card-role">{role}</p>
                <p className="person-card-description">{description}</p>
            </div>
    );
}

export default PersonCard;